import { useState } from "react";
import { Maximize2, Minimize2 } from "lucide-react";
import { Button } from "../../ui/button";
import { cn } from "../../utils/common/cn";

/**
 * Embeds a report by iframe, used for Snapshot's ad-hoc Superset views and for the
 * Power BI report, which is embedded this way rather than proxied through the
 * portfolio-performance API.
 */
export function ReportFrame({
  src,
  title,
  caption,
}: {
  src: string;
  title: string;
  caption?: string;
}) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      className={cn(
        "flex flex-col border border-border bg-background",
        expanded && "fixed inset-4 z-50 shadow-2xl",
      )}
    >
      <div className="flex items-center justify-between gap-4 border-b border-border px-4 py-2.5">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-foreground">{title}</p>
          {caption ? <p className="mt-0.5 text-[11px] text-muted-foreground">{caption}</p> : null}
        </div>
        <Button
          variant="outline"
          size="sm"
          className="h-8 gap-2 text-xs"
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? <Minimize2 className="size-3.5" /> : <Maximize2 className="size-3.5" />}
          {expanded ? "Collapse" : "Expand"}
        </Button>
      </div>
      <iframe
        src={src}
        title={title}
        allowFullScreen
        // flex-1 only when expanded: its 0% flex-basis overrides h-[560px] in the auto-height
        // collapsed state, shrinking the iframe to its 150px default.
        className={cn("w-full border-0 bg-secondary", expanded ? "h-full flex-1" : "h-[560px]")}
      />
    </div>
  );
}
